import { partnerServices } from "../../config/axios";
import {
    TWO_FA_UPDATE_FLAGS_SUCCESS,
    TWO_FA_UPDATE_FLAGS_FAILED,
    LOADING_TWO_FA_UPDATE_FLAGS,
    NETWORK_ERROR_TWO_FA_UPDATE_FLAGS,
} from "../types";

const updateFlagsTwoFa = (data, authTokenIs) => async (dispatch) => {
    dispatch({
        type: LOADING_TWO_FA_UPDATE_FLAGS,
    });

    await partnerServices
        .post("updtaeFlags", data, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case 'success':
                    dispatch({ type: TWO_FA_UPDATE_FLAGS_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: TWO_FA_UPDATE_FLAGS_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_TWO_FA_UPDATE_FLAGS,
                payload: err,
            });
        }
        );
};
export { updateFlagsTwoFa };
